import React from 'react';

const WelcomePageConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/',
			exact: true,
			component: React.lazy(() => import('./WelcomePage'))
		}
	]
};

export default WelcomePageConfig;
